module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "ch_01"
    }
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "page3"
    }
  })]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("HE HAWKESBURY was a lovely river, wide and calm, the water dimply green, the cliffs golden in the sun, and white birds roosting in the trees like so much washing. It was a sweet thing of a still morning, the river-oaks whispering and the land standing upside down in the water.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They called us the Colony of New South Wales. I never liked that. We wasn’t new anything. We was ourselves.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The Hawkesbury was where the ones come that was sent out. Soon’s they got their freedom, this was where they headed. Fifty miles out of Sydney and not a magistrate or a police to be seen. A man could pick out a bit of ground, get a hut up, never look back.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("You heard that a lot. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Never looked back.")])])]), _c('p', [_c('a', {
    attrs: {
      "id": "page3"
    }
  }), _c('a', {
    attrs: {
      "id": "page4"
    }
  })]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("That made it a place with no grannies and no grandpas. No aunties, no uncles. No past.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Pa started a boatman on the Thames. Then he was sent out, what for I never knew. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eighteen-oh-six, Alexander transport. ")]), _vm._v("I was a pestering sort of child but that was all he’d ever say, sitting in the armchair smiling away at nothing and smoothing the nap of the velvet.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Thornhills was in a big way. Three hundred acres of good riverfront land and you had to go all the way up the river to Windsor before you saw a house grand as ours. Pa had got his start in the old "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hope")]), _vm._v(", carrying other men’s grain and meat down the river to Sydney. Given that away, now he had his own corn and wheat, beef and hogs, and let other men do the carting of them.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But still a boatman at heart. Always a couple of skiffs down at the jetty, and when they put in the new road to the north he saw an opening, got a punt going. A shilling for a man, half a crown for a man on a horse, sixpence a head for cattle. Where you had people you needed an inn, so he built the Ferryman’s Arms, had George Wheeler run it for him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I never saw Pa lift an axe or carry a stick of firewood and he had other men now to do the rowing for him. Done enough work for any man’s lifetime, he’d say. Of a morning he’d eat his breakfast, light his pipe, go out to where the men were standing with their hoes and spades. Jemmy Katter, Bob Dodd, Dickie Parson, three or four others. Assigned from Government, serving their time like he’d done. Sent out from London the most of them, never seen a spade in their lives before.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page4"
    }
  }), _c('a', {
    attrs: {
      "id": "page5"
    }
  })]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("He’d set them to chipping between the corn rows, mucking out the hog-pens. Fill his pipe and stand watching them work. Point and call out if he thought they wasn’t doing it right.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He made them call him "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sir")]), _vm._v(". A flogging if they forgot.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("When you done as well as Pa had, no one said "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sent out ")]), _vm._v("or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("worn the broad arrow")]), _vm._v(". Now he was what they called an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("old colonist")]), _vm._v(". Still plenty of folk who wouldn’t put their feet under the same table as an emancipist or invite him into their house. As far as some people went, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sent out ")]), _vm._v("meant tainted for all time. You and your children and your children’s children. But for other folk, money had a way of blunting the hard shapes of the past. Dressing it up in different words.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Pa was Mr Thornhill of Thornhill’s Point now, but he had some habits that were from before. Of an afternoon he’d get a bit of bread and go out on the verandah. Sit on a hard bench beside the window—didn’t want a cushion—with the bread and a glass of rum-and-water beside him on the sill. He’d put his telescope up to his eye and look down the river where you’d see the boats from Sydney come round the last spur into Thornhill’s Reach. Sliding up fast if the tide was with them, or having to get out the oars if it was sucking back out to sea. Other times he’d swing it round the other way, to the reedy place where the First Branch wound down from among the hills. But mostly he’d look straight across the river up at the line of bush along the top of the cliffs. Nothing up there, only rocks and trees and sky, but he’d sit by the hour watching, the leather worn through to the brass where his hand clamped round it.")]), _vm._v(" "), _c('p', {
    staticClass: "tind"
  }, [_vm._v("∼")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page5"
    }
  }), _c('a', {
    attrs: {
      "id": "page6"
    }
  })]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', [_vm._v("I was born in the year eighteen-sixteen, Sarah Thornhill, named after my mother. She was Sarah but always called Sal. I was the baby of the family, why I was called Dolly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Never liked "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dolly")]), _vm._v(". Never wanted to be a doll.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Next above me was Mary, nearly three years older and never let me forget it. Got the side of the bed near the fire. Pushed ahead when we went up the stairs. You know, silly things, but they matter when you’re little.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I had three brothers too, all of them older.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Johnny was two years above Mary. Always with a scheme in his head. Got a lot of lemons once and rigged up a thing to get the juice. Begged some sugar from Ma, set up a stall down at the punt, made a shilling or two.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Bub was two years again above him. Even as a boy Bub was like an old man, sober and slow. Never went anywhere without a hoe and if he saw a thistle he’d stop and grub it out. It was him got the lemons for Johnny. Him got the hiding for it, too.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The oldest of us was Will. Fifteen when I was born and already out on the boats doing a man’s work. Will was away more than he was home. Up and down the coast with the cedar. Over to New Zealand for the seals"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(". ")]), _vm._v("Be away so long I’d think he was never coming back, half a year or more.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Captain Thornhill, people called him, though he was really only Will Thornhill who’d worked his way up. Never got his papers, nothing like that. Didn’t read, see. None of us did.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("Pa had no time for learning. Could sign his name but often said how a few acres and a flock of sheep was a better gift to your children than anything you’d get out of a book. When he ")]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("needed something on paper he got old Loveday at Beckett’s Reach to do it for him. Loveday had come free, could of done all right, but drank it all away in his miserable leaky hut. See, Pa would say. Old Loveday’s not got the taint, but tell me this, you rather have his life or mine?")])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("It was never spoke of, but Ma was not really our mother.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I had a few memories, sharp little pictures, of another mother. Will in the kitchen doorway and me sitting on the edge of the table working away at the peas in a pod while this other mother magicked them open down their backbone one by one with her thumbnail, the peas popping out into the blue-striped bowl with the grey chip on the edge. She sat puffing away on her pipe, doing the peas without having to look. The picture was so sharp it even had a smell, baccy and peas together. She’d take the pipe out of her mouth and sing, tuneless and wavery. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oranges and lemons, say the bells of Saint Clement’s, ")]), _vm._v("she’d sing. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You owe me five farthings, say the bells of Saint Martin’s")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Will with his hands under my armpits, hoisting me in the air, the underside of the shingles swinging round, the pod clutched tight in my fist while the kitchen rolled up and down and under and over, and then I was back on the table with my mouth open, would I cry or laugh I didn’t know, and Will was clattering at the stove, shouting and joking, head way up near the beams, and my mother with the peas all fallen in her pinny lap and not caring.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("Then they brought me into a dark room, summer outside but all the curtains drawn across and the shutters closed, someone leading me by the hand over to the high bed where ")]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("my mother lay, but I was frightened and shy, she was sweaty, her hair in strings, her cheeks sunk in, and her hand on the coverlet waxy and bony.")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Whoever was with me, I could feel their hand at my back, pushing, they wanted me to kiss the yellow face on the pillow. Her eyes slid sideways at me, she was smiling, but her lips were so white and dry and her face nothing but wrinkled skin sliding over the bone. I pulled back, how could I kiss such a thing! Her hand crawled towards me over the coverlet and she touched me on the shoulder, top of the head, shoulder again, then the hand fell back and they let me go away.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Like a dream, that first mother melted away and there was another person we called Ma.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Pa had no stories but Ma had enough for the both of them. Turned over the places and names and dates like coins in her hand, counted and re-counted them for the pleasure of it. Her Daddy was in the sugar trade and she grew up in a house at Brixton-Hill, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("on the north side, that’s the superior side")]), _vm._v(". A husband something in the army, she was Margaret Grant. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Come free ")]), _vm._v("to New South Wales along with him. Then he died.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I come up the river to help your pa, she’d say. Your mother too sick to care for a houseful of children. Then by and by we was wed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I loved how neat it was, the way she told it, then and now stitched up tight.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("Ma had a scurrying way with her, tilting forward from the waist like a hen in a hurry. Always putting something to rights. She never forgot the stain Pa carried. But the way she saw it, ")]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("it was a wife’s job to hide it, even if she couldn’t wash it out.")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("She had a headful of all the things you did so no one would know you had the taint. Elbows off the table, remember Dolly, she’d say, and a well-bred person leaves a scrap on their plate. She’d be running after us with our bonnets when we went outside, did we want to look like blackfellows? Church, rain or shine, every Sunday, that fog of mothballs. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("We have left undone those things which we ought to have done and we have done those things which we ought not to have done. ")]), _vm._v("Church was full of hard words, but those were plain small ones mortared together into something that nothing could get into or out of.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Pa did his best, but he’d forget. Eat off his knife, or say "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("victuals, ")]), _vm._v("when Ma thought that was vulgar.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It’s food, William, she’d say. Or comestibles.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("By God Meg, he’d say. Combustibles is it?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He’d laugh, but then he’d reach over and touch her arm.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Oh, I’m an ignorant feller, he’d say. Lucky she took me, your ma.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Humour not Ma’s long suit, but she’d smile then, and when she did that you could see what they shared. The two of them, no one else in the room.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I’d seen Pa drink out of the teapot spout, but when Ma was watching he cramped up his thick fingers into the silly little teacup handle. At table he’d work the silverware the way Ma liked, squash the peas onto the fork and line it up with the knife when he’d finished.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("If we’d go to him about something he’d say, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Best see what your Ma says. ")]), _vm._v("Not that he was a weak man, Pa. Not by any manner ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("of means. But he’d done his bit. Got us the house, the land, the money. Found us a good mother. Now he could sit back. Knew Ma would see to it his children had a clean break with the past. Leave it behind the way he had.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Pa enjoyed his money. You once gone without, he’d say, you know it’s better to have than not. The best if you can get it. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The best ")]), _vm._v("meant meat every day. All the potatoes you could eat, with sweet fresh butter.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And oranges. Never seen an orange before I were twelve year old, he’d say, not to eat. It was a bit of joke between me and Mary, one of the things we did share. Every time Anne brought in a dish of oranges Pa would force his great square thumb into one and lever up a piece of peel. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Never seen an orange before I were twelve year old, ")]), _vm._v("he’d say. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Not to eat")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Mary and me would slip each other a look. She’d suck her lips into a fishmouth and I’d have to make out I was snorting because of my tea going down the wrong way.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Ma would give us the rounds of the kitchen later. Your pa known some hard times, she’d say. You silly girls don’t know the half of it.")]), _vm._v(" "), _c('p', {
    staticClass: "tind"
  }, [_vm._v("∼")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("There was Mrs Devlin in the kitchen and Anne the maid-of-all-work. A woman once a week for the washing and a native boy for the wood. Still, girls of our class, well-off but not gentry, we learned all the household things. Mrs Devlin showed us how to do the bread and keep the yeast bottle going, the basic things like that, and Ma taught us "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the finer points")]), _vm._v(", how to slice the bacon ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("thin and the way to fold the flour into a sponge cake so it stayed light. Mary liked working in the kitchen, but I got sick of Mrs Devlin forever on about Mr Devlin that died, and Ma saying oh yes, how hard life was for a poor widder. I didn’t want to spend my time sweating away at the stove, everything eaten by half past twelve and not a thing to show for it.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("I learned how to make a loaf and pickle a brisket of beef and all the rest of it, because that’s what a girl was supposed to know. But I’d get away soon’s I could. I had a place of my own, a cave in the bush up behind the house. It was a steep scramble but not far. Close enough so I could be back if Ma called, she’d never know I was gone. Far enough, it was my own world. That country was full of overhangs where the soft yellow rock was worn away underneath, but this one was big enough to stand in and full of light the colour of honey. The floor level, soft with dry sand fallen from the roof, never wet by rain, not since the world began.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I set up house there, the way a child likes to do. Had a chipped teacup and a milk-jug with no handle and a dipper, because on top of the cave was a hole, made by man or nature I didn’t know, that filled with sweet water after rain. The lip of the cave was on a level with the treetops. You could sit there and watch the breeze shivering through the leaves and the river beyond, a band of colour like a muscle. When you sat in the cave the bush sounds come to you sharper. It was like a big ear, listening.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Mary never wanted to go up there. Said she couldn’t see why you’d want to climb up there and get all over prickles just to ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("sit on the hard ground. That suited me. The birds were company enough. One I called the What Bird, it had a call like a question. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dit dit dit dit dit? ")]), _vm._v("it would go, and I’d screw my mouth round to answer, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dit dit dit dit?")])])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("I thought about flying, stood sometimes on the edge of the rock and wondered. But much as I’d of liked to, and young as I was, I had the sense to know I’d have to wait for some other way to fly.")])])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2de8bc5b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802194459_ch01.vue
// module id = 87
// module chunks = 0